var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('nav-bar'),_c('div',{staticClass:"main-container"},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('keep-alive',{attrs:{"include":"homepage,more"}},[_c(Component,{tag:"component"})],1)]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }